import CloseIcon from "@mui/icons-material/Close";
import React, { useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import { ASSETS } from "../../utils/config";
import * as Styled from "./styles";
import Button from "../Button";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonWithIcon from "../ButtonWithIcon";
import CustomSlider from "../Slider";

const fileIcons = {
  png: ASSETS.img,
  jpg: ASSETS.img,
  jpeg: ASSETS.img,
  doc: ASSETS.doc,
  docx: ASSETS.doc,
  pdf: ASSETS.pdf,
  xls: ASSETS.xls,
  xlsx: ASSETS.xls,
};

function AIGenerator({
  closeModalHandler,
  files,
  handleFileChange,
  handleFileRemove,
  handleSubmit,
  loading,
  data,
  handleInput,
}) {
  const fileInputRef = useRef(null);
  const [showFilters, setShowFilters] = useState(false);

  const { prompt, segmentCount, wordCount, variation } = data;

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: [NativeTypes.FILE],
    drop: (item) => {
      handleFileChange(item.files);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.Close onClick={closeModalHandler} />
        <Styled.HeaderWrapper>
          <Styled.Row>
            <Styled.Image src={ASSETS.aiBot} alt="AiIcon" />
            <Styled.Heading>AI Wheel Generator</Styled.Heading>
          </Styled.Row>
          <Styled.Row style={{ justifyContent: "space-between" }}>
            <Styled.TitleWrapper>
              <Styled.Title>Write a prompt for the AI</Styled.Title>
              <Styled.SubTitle variant="subtitle2">
                Describe the desired content or purpose for the wheel creation,
                the AI will generate it for you!
              </Styled.SubTitle>
            </Styled.TitleWrapper>
            <Styled.FilterIconWrapper>
              <Styled.FilterIcon
                src={ASSETS.filter_icon}
                onClick={() => setShowFilters(!showFilters)}
              />
            </Styled.FilterIconWrapper>
          </Styled.Row>
        </Styled.HeaderWrapper>
        <Styled.ContentWrapper>
          <Styled.FilesWrapper files={files} isActive={isActive} ref={drop}>
            {files.length ? (
              <Styled.Files>
                {files.map(({ file, id, mimeType, loading }) => {
                  return (
                    <Styled.File>
                      <Styled.FileContent>
                        <Styled.FileIcon src={fileIcons[mimeType]} />
                        <Styled.FileName variant="subtitle3">
                          {file.name}
                        </Styled.FileName>
                      </Styled.FileContent>
                      <div style={{ width: "10%" }}>
                        {loading ? (
                          <CircularProgress size={10} />
                        ) : (
                          <CloseIcon
                            onClick={() => handleFileRemove(id)}
                            color={"gray"}
                            style={{ width: 10, height: 10, cursor: "pointer" }}
                          />
                        )}
                      </div>
                    </Styled.File>
                  );
                })}
              </Styled.Files>
            ) : (
              <Styled.AttachTextWrapper>
                <Styled.AttachText variant="subtitle2" component="subtitle2">
                  Drop images and documents here or attach files from the button
                  below
                </Styled.AttachText>
              </Styled.AttachTextWrapper>
            )}
          </Styled.FilesWrapper>
          <Styled.TextArea
            onChange={(e) => handleInput("prompt", e.target.value)}
            name="Ai "
            defaultValue=""
            value={prompt}
            placeholder="Your Prompt"
          />

          {showFilters ? (
            <Styled.FiltersWrapper>
              <CustomSlider
                label="Segment count"
                min={4}
                max={10}
                value={segmentCount}
                steps={1}
                onChange={(e, val) => handleInput("segmentCount", val)}
                infoText={"Adjust the number of segments generated"}
              />
              <CustomSlider
                label="Word count"
                min={100}
                max={1000}
                value={wordCount}
                steps={100}
                onChange={(e, val) => handleInput("wordCount", val)}
                infoText={
                  "Adjust the total number of words generated in the Wheel"
                }
              />
              <CustomSlider
                label="Variation"
                min={0.0}
                max={1.0}
                value={variation}
                steps={0.1}
                onChange={(e, val) => handleInput("variation", val)}
                infoText={
                  "Adjust how much the Wheel's language will deviate from linked Documents & URLs"
                }
              />
            </Styled.FiltersWrapper>
          ) : null}
        </Styled.ContentWrapper>

        <Styled.ButtonWrapper>
          <div>
            <input
              type="file"
              multiple
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e.target.files)}
              accept="application/vnd.ms-excel application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/msword, application/pdf, image/png, image/jpeg, image/jpeg"
            />
            <ButtonWithIcon
              icon={ASSETS.AttachIcon}
              disabled={loading}
              onClick={handleFileButtonClick}
            >
              Attach Files
            </ButtonWithIcon>
          </div>
          <Button
            onClick={handleSubmit}
            isLoading={loading}
            style={{ width: "10vw" }}
          >
            Generate
          </Button>
        </Styled.ButtonWrapper>
      </Styled.Wrapper>
    </>
  );
}

export default AIGenerator;
